"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinReceiver = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var framer_motion_1 = require("framer-motion");
var react_1 = require("react");
var _hooks_1 = require("../../hooks");
var FinReceiverContainer = (0, framer_motion_1.motion)(styled_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""]))));
function FinReceiver(props) {
    var _this = this;
    // prop destruction
    var className = props.className;
    // lib hooks
    var _a = (0, framer_motion_1.useAnimate)(), scope = _a[0], animate = _a[1];
    var _b = (0, _hooks_1.useFin)(), contentMap = _b.contentMap, currentPath = _b.currentPath, initialize = _b.initialize;
    var _c = (0, _hooks_1.useFinEnd)(), _ = _c[0], registerEnd = _c[1];
    var _d = (0, _hooks_1.useFinStart)(), __ = _d[0], registerStart = _d[1];
    // state, ref, querystring hooks
    var _e = (0, react_1.useState)(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = (0, react_1.useState)(contentMap[currentPath]), children = _f[0], setChildren = _f[1];
    // form hooks
    // query hooks
    // calculated values
    // effects
    (0, react_1.useEffect)(function () {
        if (!isLoading) {
            animate(scope.current, {
                opacity: 1,
            }, { duration: 0.2 });
        }
    }, [isLoading]);
    (0, react_1.useEffect)(function () {
        registerEnd(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                setIsLoading(false);
                setChildren(contentMap[event.currentPath]);
                if (scope.current) {
                    animate(scope.current, {
                        opacity: 1,
                    }, { duration: 0.2 });
                }
                return [2 /*return*/];
            });
        }); });
        registerStart(function () {
            animate(scope.current, {
                opacity: 0,
            }, { duration: 0.2 });
        });
        initialize();
    }, []);
    // handlers
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)(FinReceiverContainer, { className: className, initial: { opacity: 0 }, ref: scope, children: children }));
}
exports.FinReceiver = FinReceiver;
var templateObject_1;
//# sourceMappingURL=FinReceiver.js.map